<div class="filter-pill-list">
    <p *ngFor="let filter of activeFilterDefinitions; trackBy: trackByFilterKey">
        <span class="badge badge-pill badge-secondary" [pTooltip]="filter.tooltipValue" [tooltipDisabled]="!filter.tooltipValue" tooltipPosition="right">
            <span class="filter-label">{{filter.label}}:</span> {{filter.displayValue}}
            <button type="button" class="btn-close" aria-label="Close" (click)="closePill(filter.key)">X</button>
        </span>
    </p>
</div>
